export function parseSavedUser(raw) {
  if (!raw) return null;
  try {
    const u = JSON.parse(raw);
    if (u && typeof u === "object" && u.email) {
      return { email: String(u.email), username: u.username ? String(u.username) : null };
    }
    return null;
  } catch (e) {
    return null;
  }
}

export function buildRedirectUrl(user, baseUrl) {
  const base = (baseUrl || "https://partners.strongesim.com").replace(/\/+$/, "");
  const params = new URLSearchParams({ welcome: "1" });
  if (user && user.email) {
    params.set("email", user.email);
    if (user.username) params.set("name", user.username);
  }
  return `${base}/?${params.toString()}`;
}
